import { useEffect, useState } from 'react';
import { supabase } from '../supabase.js';
import { useAuth } from '../AuthContext.jsx';
import { renderMd, fetchPackageText } from '../lib/markdown.js';

const SIGNED_URL_TTL = 300;

export default function Strategy() {
  const { activeId, activeClient } = useAuth();
  const [state, setState] = useState({ loading: true, error: null, html: null });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setState({ loading: true, error: null, html: null });
      if (!activeId) return;
      // The live strategy doc is <client>/strategy.md (regenerated on plan
      // approval). Session 5: before the first plan is approved, a client
      // with an approved baseline reads <client>/analysis/strategy.md.
      for (const path of [`${activeId}/strategy.md`, `${activeId}/analysis/strategy.md`]) {
        try {
          const md = await fetchPackageText(supabase, path, SIGNED_URL_TTL);
          if (cancelled) return;
          setState({ loading: false, error: null, html: renderMd(md) });
          return;
        } catch (e) {
          if (cancelled) return;
        }
      }
      setState({ loading: false,
                 error: 'Your strategy is being prepared. Check back after your first quarterly plan is approved.',
                 html: null });
    })();
    return () => { cancelled = true; };
  }, [activeId]);

  if (state.loading) return <p className="lede">Loading your strategy…</p>;
  if (state.error)   return (
    <div className="empty">
      <h2>Your strategy is being prepared</h2>
      <p>{state.error}</p>
    </div>
  );

  return (
    <article className="strategy-doc" dangerouslySetInnerHTML={{ __html: state.html }} />
  );
}
